<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData"
  [nextOffset]="nextOffset" [previousOffset]="previousOffset" (offset)="getData($event)"
  (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [dataLoaded]="dataLoaded">
</app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Mapping Braio with Category</div>
  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
        (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>

    <!-- <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
        (change)="onCategoryChange($event.target.selectedIndex)">
        <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
      </select>
    </div> -->

    <div class="row">
      <div class="col-md-12 pad-15 category">
        <div class="height-40" [hidden]="categoryLoaded">
          <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;" [disabled]="ticket.isDisabled"
          (change)="onCategoryChangeDropDown(ticket,$event.target.value)" id="ticket_{{ticket.id}}"
          [hidden]="!categoryLoaded">
          <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
        </select>
      </div>
    </div>



    <div class="form-group">
      <div class="form-group">
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="urlVal" placeholder="Enter URL">
      </div>
    </div>



    <!-- <div class="form-group matFrom" >
                        <mat-form-field>
                          <mat-label class="font-13">Select Working Category</mat-label>
                          <mat-select [(ngModel)]="categoryArr" multiple>
                            <mat-option *ngFor="let category of categories" [value]="category.id" class="font-13">{{category.name}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                  
             </div> -->



  </div>

  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>